import { createApp } from 'vue'
import './style.css'
import '@fontsource/poppins/latin-400.css';
import '@fontsource/poppins/latin-500.css';
import App from './App.vue'
import router from './router'

createApp(App).use(router).mount('#app')
